import { Injectable, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { VendorService } from './vendor.service';




@Injectable({
  providedIn: 'root'
})
export class UtilsDataService {
  jobDetails: any = {}
  interviewers: any = {}
  headers: any = {}
  appliedUserDetails: any = {};
  getConsolidateData: any = {};
  checkCompanyDetails: boolean = false
  checkMatrimonyDetails: boolean = false
  checkPlanDetails: boolean = false
  emailNotifications: any = {};
  updateCategories: any = {};
  advertDetails: any = {}
  examDetails: any = {}
  singleQuestion: any = {}
  seeker_UUID: ""
  seeker_USERID: ""
  matriPlanCheck: boolean = false
  dbPlansCheck: boolean = false
  advertPlansCheck: boolean = false
  private advertUuid: string | null = null;
  adminAdvertDetails: any = {}
  adminAdvertUUID: string = ""
  adminBlogDetails: any = {}
  adminBlogUUID: string = ""
  setCompanyDetails: any = {};
  setMatrimonyDetails: any = {};
  scheduleDetails: any = {};
  disputeDetails: any = {};
  isEditMode: boolean = false; // ✅ Add this line
  registredEmail: any;
  jobStatus:string=""
  vendorApplicationObj: any = {
    jobs: "N",
    matri: "N",
    e_shopping: "N",
  };
  updatedVendorDetails: any = {};
  detailViewStatus: boolean = false
  jobRefId: String = ""
  enabledVendorApplications: any = []
  setAdvertUuid(uuid: string) {
    this.advertUuid = uuid;
  }
  qaEnable: boolean = false;
  getAdvertUuid(): string | null {
    return this.advertUuid;
  }

  // Signal to hold seeker_uuid
  private seekerUuid = signal<string | null>(null);

  // Method to set seeker_uuid
  setJobSeekerUuid(user_uuid: string): void {
    this.seekerUuid.set(user_uuid);
  }

  matriUuid = signal<any | null>(null);

  // Method to set seeker_uuid
  setMatriUuid(user_uuid: any): void {
    this.matriUuid.set(user_uuid);
  }


  examValues = signal<any | null>(null);

  // Method to set seeker_uuid
  setExamValues(data: any): void {
    this.examValues.set(data);
  }


  id = signal<number | null>(null);



  // profile_uuid start
  private _matriData = signal<any>(null); // You can type this better if needed

  matriData = this._matriData.asReadonly(); // To read from outside

  setMatriData(data: any) {
    this._matriData.set(data);
    console.log("uuid data", data)
  }
  // profile_uuid end


  // Method to get seeker_uuid
  getJobSeekerUuid(): string | null {
    return this.seekerUuid();
  }

  registredUuid : string=""

  jobFilterObj: {
    experience_type: string[];
    gender: string[];
    industry_id: number | null;
    job_position: string | null;
    job_type: string[];
    location: string | null;
    min_salary: number | null;
    max_salary: number | null;
    premium_jobs: string;
    required_skills: string | null;
    searchKeyword: string | null;
    timestamp: string[];
  }

  jobPlanFeatures = {
    ADD_OFFICE_BRANCHES: false,
    SMS_NOTIFICATIONS: false,
    SINGLE_USER_ACCESS: false,
    RESUMES_REPO_DESCRIPTION: false,
    PUSH_NOTIFICATIONS: false,
    PREMIUM_JOB_POSTINGS: false,
    MULTIPLE_USER_ACCESS: false,
    JOBSEEKERS_RESUME_ACCESS: false,
    JOBSEEKERS_PROFILE_ACCESS: false,
    EMPLOYEE_CREATION: false,
    EMAIL_NOTIFICATIONS: false,
    EMAIL_HELPTEXT: false,
    CONDUCT_ONLINE_EXAMS: false,
    ASSIGNING_INTERVIEWERS: false,
    WHATSAPP_NOTIFICATIONS: false
  };

  matriPlanFeatures = {
    VIEW_PAN_INDIA_PROFILES: false,
    VIEW_VERIFIED_PROFILES: false,
    VIEW_CONTACT_DETAILS: false,
    VIEW_PREMIUM_PROFILES: false,
    EXPRESS_INTEREST_IN_PROFILES: false,
    ACCEPT_INTERESTED_MEMBERS: false,
    MEMBERS_VISITED_YOUR_PROFILE: false,
    MEMBERS_VIEWED_YOUR_CONTACTS: false,
    SHORTLIST_SELECTED_PROFILES: false,
    BLOCK_UNWANTED_PROFILES: false,
    EMAIL_NOTIFICATIONS: false,
    WHATSAPP_NOTIFICATIONS: false,
    PUSH_NOTIFICATIONS: false,
    PROFILE_BOOSTING: false,
    PREMIUM_PROFILES: false,
    PROFILES_YOU_VISITED: false,
    POST_PREMIUM_PROFILES: false,
    SHARE_PREMIUM_PROFILES: false,
  }
  dbPlanFeature = {
    ACTIVE_RESUMES: false,
    FREELANCER_RESUMES: false,
    INSTANT_RESUME_DOWNLOAD: false,
    PREMIUM_RESUMES: false,
    SMART_SEARCH_FILTERS: false,
    VERIFIED_RESUMES: false,
    VOLUNTEER_RESUMES: false,
  }

  filterObject = {
    experience_type: [],
    gender: [],
    industry_id: null,
    job_position: null,
    job_type: [],
    location: null,
    min_salary: null,
    max_salary: null,
    premium_jobs: "",
    required_skills: null,
    searchKeyword: null,
    timestamp: []
  };
  private searchData: any = {};

  setSearchData(data: any) {
    this.searchData = data;
  }

  getSearchData() {
    return this.searchData;
  }

  private _examDetails$ = new BehaviorSubject<any[]>([]);
  examDetails$ = this._examDetails$.asObservable();

  // Setter to update exam list from any component
  setExamDetails(exams: any[]) {
    this._examDetails$.next(exams);
  }

  // Getter to read synchronously
  getExamDetails(): any[] {
    return this._examDetails$.getValue();
  }
  // 🔥 Signal to store branchId
  branchId = signal<number | null>(null);

  setBranchId(id: number) {
    this.branchId.set(id);
  }

  clearBranchId() {
    this.branchId.set(null);
  }
}
